@if (loadingService.isLoading()) {
<div class="progress-spinner-container">
  <div class="lottie-wrapper">
    <ng-lottie [options]="lottieOptions" width="120px" height="120px" />
  </div>
</div>
}
